import type { StaticSharedField } from './types';
import type { intensityOrAbsoluteDropdownValue } from '/business/shared/components/pages/question/types';
import useAbsoluteEmissions from '/business/shared/components/pages/question/formats/staticSharedFields/useAbsoluteEmissions';

export default function useScopeCombined13Data({
  label,
  subLabel,
  intensityOrAbsoluteDropdownValue,
  errMsg,
}: {
  label?: string;
  subLabel?: string;
  intensityOrAbsoluteDropdownValue: intensityOrAbsoluteDropdownValue[];
  errMsg?: string;
}): StaticSharedField {
  return useAbsoluteEmissions({
    propName: 'scope_combined13_data_amount',
    dropdownPropName: 'scope_combined13_data_amount_unit',
    label: label,
    subLabel: subLabel,
    intensityOrAbsoluteDropdownValue,
    errMsg,
  });
}
